import { Link, useLocation } from "react-router-dom";
import { useState, useEffect, useRef } from "react";
import { motion } from "framer-motion";
import Logo from "../assets/characters/Bharatparikhsa.png";

/* Dropdown animation */
const popVariants = {
  hidden: { opacity: 0, y: -10 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.2, ease: "easeOut" },
  },
};

function Navbar({ userName, handleLogout }) {
  const location = useLocation();

  /* 🔽 Scroll hide/show */
  const [showNavbar, setShowNavbar] = useState(true);
  const lastScrollY = useRef(0);

  useEffect(() => {
    const handleScroll = () => {
      const currentY = window.scrollY;

      if (currentY > lastScrollY.current && currentY > 80) {
        setShowNavbar(false); // scroll down
      } else {
        setShowNavbar(true); // scroll up
      }

      lastScrollY.current = currentY;
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const userInitial = userName ? userName.charAt(0).toUpperCase() : "";

  /* Common nav item style */
  const navItemClass =
    "px-3 py-1.5 rounded-md font-semibold text-[#8B5A2B] transition-all duration-200 hover:bg-[#f3e7db]";

  return (
    <motion.nav
      initial={{ y: 0 }}
      animate={{ y: showNavbar ? 0 : -90 }}
      transition={{ duration: 0.35, ease: "easeInOut" }}
      className="fixed top-0 left-0 w-full z-50 shadow-md rounded-b-2xl"
      style={{ backgroundColor: "#ffffff", fontFamily: "'Baloo 2', cursive" }}
    >
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex justify-between items-center h-[64px]">

          {/* LOGO */}
          <Link to="/" className="flex items-center gap-0.5">
            <img src={Logo} alt="Logo" className="h-14 md:h-16 lg:h-18 w-auto" />
            <span
              className="text-xl tracking-wide"
              style={{ color: "#8B5A2B", fontWeight: 800 }}
            >
              bharatparikhsa
            </span>
          </Link>

          {/* NAV LINKS */}
          <ul className="hidden md:flex items-center gap-2 text-base">

            <li><Link to="/" className={navItemClass}>Home</Link></li>
<li>
  <Link to="/groups" className={navItemClass}>
    Playlists
  </Link>
</li>

            {/* TESTS */}
            <li className="relative group">
              <button className={`${navItemClass} flex items-center gap-1`}>
                Tests <span className="text-sm">▾</span>
              </button>

              <motion.ul
                variants={popVariants}
                initial="hidden"
                animate="visible"
                className="
                  absolute left-0 top-full mt-2 w-56
                  rounded-xl shadow-lg bg-white py-2 z-50
                  opacity-0 invisible
                  group-hover:opacity-100 group-hover:visible
                  transition-all duration-200
                "
              >
                {[
                 // ["Public Tests", "/test"],
                  ["Create Test", "/createtest"],
                  ["Explore Tests", "/public-tests"],
                  ["My Tests", "/mytests"],
                  ["Practice", "/tests/practice"],
                  ["Timed", "/tests/timed"],
                  ["Exam", "/tests/exam"],
                  
                  ["Adaptive", "/tests/adaptive"],
                ].map(([label, path]) => (
                  <li key={path}>
                    <Link
                      to={path}
                      className="block px-4 py-2 rounded-md hover:bg-[#f3e7db] text-[#5A3A1B]"
                    >
                      {label}
                    </Link>
                  </li>
                ))}
              </motion.ul>
            </li>

            {/* AI TOOLS */}
            <li className="relative group">
              <button className={`${navItemClass} flex items-center gap-1`}>
                AI Tools <span className="text-sm">▾</span>
              </button>

              <motion.ul
                variants={popVariants}
                initial="hidden"
                animate="visible"
                className="
                  absolute left-0 top-full mt-2 w-56
                  rounded-xl shadow-lg bg-white py-2 z-50
                  opacity-0 invisible
                  group-hover:opacity-100 group-hover:visible
                  transition-all duration-200
                "
              >
                <Link
                  to="/question-extraction"
                  className="block px-4 py-2 rounded-md hover:bg-[#f3e7db] text-[#5A3A1B]"
                >
                  Question Extraction
                </Link>
                <Link
                  to="/flashcards"
                  className="block px-4 py-2 rounded-md hover:bg-[#f3e7db] text-[#5A3A1B]"
                >
                  Flashcards
                </Link>
                <Link
  to="/math-drills"
  className="block px-4 py-2 rounded-md hover:bg-[#f3e7db] text-[#5A3A1B]"
>
  Math Drills
</Link>
<Link
  to="/focus-game"
  className="block px-4 py-2 rounded-md hover:bg-[#f3e7db] text-[#5A3A1B]"
>
  focusgame
</Link>
              </motion.ul>
            </li>

            <li className="relative group">
  <button className={`${navItemClass} flex items-center gap-1`}>
    Game <span className="text-sm">▾</span>
  </button>

  <motion.ul
    variants={popVariants}
    initial="hidden"
    animate="visible"
    className="
      absolute left-0 top-full mt-2 w-56
      rounded-xl shadow-lg bg-white py-2 z-50
      opacity-0 invisible
      group-hover:opacity-100 group-hover:visible
      transition-all duration-200
    "
  >
    <Link
      to="/game"
      className="block px-4 py-2 rounded-md hover:bg-[#f3e7db] text-[#5A3A1B]"
    >
      🎮 Test Game
    </Link>

    <Link
      to="/math-drills"
      className="block px-4 py-2 rounded-md hover:bg-[#f3e7db] text-[#5A3A1B]"
    >
      🧮 Math Drills
    </Link>

    
 <Link
  to="/observation-game"
  className="block px-4 py-2 rounded-md hover:bg-[#f3e7db] text-[#5A3A1B]"
>
   Observation-game
</Link>
<Link
  to="/focus-game"
  className="block px-4 py-2 rounded-md hover:bg-[#f3e7db] text-[#5A3A1B]"
>
  🎯 Focus Game (Classic)
</Link>

<Link
  to="/focus-game-v2"
  className="block px-4 py-2 rounded-md hover:bg-[#f3e7db] text-[#5A3A1B]"
>
  🚀 Focus Game (White Room)
</Link>

<Link
  to="/memory-game"
  className="block px-4 py-2 rounded-md hover:bg-[#f3e7db] text-[#5A3A1B]"
>
  🧠 Memory Game (Classic)
</Link>

<Link
  to="/memory-game-v2"
  className="block px-4 py-2 rounded-md hover:bg-[#f3e7db] text-[#5A3A1B]"
>
  🚀 Memory Game (White Room)
</Link>
 <Link
  to="/car-game"
  className="block px-4 py-2 rounded-md hover:bg-[#f3e7db] text-[#5A3A1B]"
>
  car game
</Link>
<Link
  to="/airstrike"
  className="block px-4 py-2 rounded-md hover:bg-[#f3e7db] text-[#5A3A1B]"
>
  ✈️ Air Strike
</Link>
  </motion.ul>
</li>
            <li><Link to="/about" className={navItemClass}>About us</Link></li>
            {/*<li><Link to="/contact" className={navItemClass}>Contact</Link></li>*/}
            <li><Link to="/support" className={navItemClass}>Support ❤️</Link></li>
          </ul>

          {/* USER / AUTH */}
          {userName ? (
            <li className="relative group list-none">
              <button
                className="flex items-center gap-2 px-2 py-1.5 rounded-md
                           text-[#5A3A1B] font-semibold
                           hover:bg-[#f3e7db] transition"
              >
                <span className="text-sm">
                  Hi, <span className="capitalize">{userName}</span>
                </span>

                <div
                  className="w-9 h-9 rounded-full flex items-center justify-center
                             text-white font-bold text-sm"
                  style={{ backgroundColor: "#8B5A2B" }}
                >
                  {userInitial}
                </div>
              </button>

              <div
                className="
                  absolute right-0 top-full mt-2 w-44
                  rounded-xl shadow-lg bg-white py-2 z-50
                  opacity-0 invisible
                  group-hover:opacity-100 group-hover:visible
                  transition-all duration-200
                "
              >
                <Link
                  to="/activity"
                  className="block px-4 py-2 rounded-md hover:bg-[#f3e7db] text-[#5A3A1B]"
                >
                  📊 My Activity
                </Link>

                <div className="my-1 h-px bg-gray-200" />

                <button
                  onClick={handleLogout}
                  className="w-full text-left px-4 py-2 rounded-md
                             text-red-600 hover:bg-[#f3e7db]"
                >
                  Logout
                </button>
              </div>
            </li>
          ) : (
            <div className="flex items-center gap-3">
              <Link
                to="/login"
                className="px-4 py-1.5 rounded-md font-semibold
                           text-[#8B5A2B] hover:bg-[#f3e7db] transition"
              >
                Login
              </Link>
              <Link
                to="/signup"
                className="px-4 py-1.5 rounded-md font-semibold
                           bg-[#8B5A2B] text-white hover:opacity-90 transition"
              >
                Signup
              </Link>
            </div>
          )}

        </div>
      </div>
    </motion.nav>
  );
}

export default Navbar;
